import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { actions, selectors } from 'app-webtech-core';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import { AssetsFileResolver } from '../../containers/AssetsFileResolver';

const Wrapper = styled.div`
  display: flex;
  float: left;
`;

const MenuButton = styled(IconButton)`
  float: left;
  margin-left: 10px !important;
  margin-right: 3px !important;
  margin-top: 4px !important;
  color: #e1e1e1 !important;

  .icon {
    width: 24px;
    height: 24px;
  }
`;

const Logo = styled(AssetsFileResolver)`
  float: left;
  height: 25.6px;
  margin: 0.8em 1em 0.8em 0em;
`;

const LeftSectionComponent = ({ isMenuOpen, openMenu, closeMenu }) => (
  <Wrapper>
    <MenuButton onClick={isMenuOpen ? closeMenu : openMenu}>
      {isMenuOpen ? <CloseIcon className="icon" /> : <MenuIcon className="icon" />}
    </MenuButton>
    <Logo alt="Pluto TV logo" path="images/logo-new-colored.svg" />
  </Wrapper>
);

LeftSectionComponent.propTypes = {
  isMenuOpen: PropTypes.bool.isRequired,
  openMenu: PropTypes.func.isRequired,
  closeMenu: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isMenuOpen: selectors.layout.properties(state).isMenuOpen,
});

const mapDispatchToProps = (dispatch) => ({
  openMenu: () => dispatch(actions.layout.openMenu()),
  closeMenu: () => dispatch(actions.layout.closeMenu()),
});

export const LeftSection = connect(mapStateToProps, mapDispatchToProps)(LeftSectionComponent);
